var App = App || {};

App.TeamMember = (function ($) {
    'use strict';
    
    function init() {

        // open TeamMember modal on enter
        $('[id^=open_team_member]').on('keyup', function (e) {
            if (e.which == '13')
                $(e.currentTarget.dataset.target).modal('toggle')
        })

    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.TeamMember.init();
});
